import { t } from 'ember-intl';
import {
  HdsAppFrame,
  HdsAppHeader,
  HdsAppHeaderHomeLink,
  HdsAppSideNav,
  HdsAppSideNavPortalTarget,
} from '@hashicorp/design-system-components/components';
import { BreadcrumbsItem, HelpMenu, UserMenu } from 'core/components';

<template>
  <BreadcrumbsItem
    @route="license-utilization.reports"
    @text={{t "page-title.license-utilization-reporting.reports"}}
  />
  <HdsAppFrame
    @hasHeader={{true}}
    @hasSideBar={{true}}
    id="hcp-app-frame"
    as |Frame|
  >
    <Frame.Header>
      <HdsAppHeader
        @hasA11yRefocus={{true}}
        @a11yRefocusSkipTo="app-main-content"
      >
        <:logo>
          <HdsAppHeaderHomeLink
            @route="cloud"
            @icon="hashicorp"
            @text={{t "nav.logo-aria-label"}}
            data-test-company-logo
          />
        </:logo>
        <:utilityActions>
          {{#if @controller.currentUser}}
            <HelpMenu />
            <UserMenu />
          {{/if}}
        </:utilityActions>
      </HdsAppHeader>
    </Frame.Header>

    <Frame.Sidebar>
      <HdsAppSideNav
        @isResponsive={{true}}
        @isCollapsible={{true}}
        @hasA11yRefocus={{true}}
        @a11yRefocusSkipTo="app-main-content"
      >
        <HdsAppSideNavPortalTarget
          @targetName="hds-side-nav-portal-target"
          data-test-sidebar-nav-content
        />
      </HdsAppSideNav>
    </Frame.Sidebar>
    <Frame.Main id="app-main-content" data-test-main>
      {{outlet}}
    </Frame.Main>
  </HdsAppFrame>
</template>
